<template>
  <div class="kpi-column" :class="{ 'kpi-column--collapsed': !column.isExpanded }">
    <div class="kpi-column__header" @click="toggleColumnExpanded">
      <h3 class="kpi-column__title">{{ column.label }}</h3>
      <div class="kpi-column__toggle">
        <ChevronRight v-if="!column.isExpanded" :size="16" />
        <ChevronLeft v-else :size="16" />
      </div>
    </div>

    <div  class="kpi-column__content">
      <KpiTableHeader :column="column" />
      <KpiSummaryRow  :column="column" />

      <template v-for="(kpi, index) in column.kpis" :key="index">
        <!-- <KpiSectionHeader v-if="kpi.label" :label="kpi.label" /> -->
        <!-- v-for="kpi in section.kpis" -->
        <KpiRow :column="column"
                :kpi="kpi" />
      </template>
    </div>
  </div>
</template>

<script>
import { ChevronRight, ChevronLeft } from 'lucide-vue-next';
import KpiTableHeader from './KpiTableHeader.vue';
import KpiSummaryRow from './KpiSummaryRow.vue';
import KpiSectionHeader from './KpiSectionHeader.vue';
import KpiRow from './KpiRow.vue';

export default {
  name: 'KpiColumn',

  emits: ['toggle-column-expanded'],

  components: {
    ChevronRight,
    ChevronLeft,
    KpiTableHeader,
    KpiSummaryRow,
    KpiSectionHeader,
    KpiRow
  },

  props: {
    column: { type: Object,     required: true }
  },

  methods: {
    toggleColumnExpanded() {
      this.$emit('toggle-column-expanded', { columnId: this.column.label });
    }
  }
};
</script>

<style lang="scss" scoped>
.kpi-column {
  flex-shrink: 0;
  border: 1px solid var(--bs-border-color);
  border-radius: var(--bs-border-radius-lg);
  overflow: hidden;
  transition: all 0.3s ease;
  min-width: 25rem;

  &--collapsed {
    min-width: auto;
    width: fit-content;
  }
}

.kpi-column__header {
  background-color: var(--bs-primary);
  color: white;
  padding: 0.625rem 1rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
  cursor: pointer;
  transition: background-color 0.2s;

}

.kpi-column__title {
  font-size: .875rem;
  font-weight: 600;
  letter-spacing: 0.025em;
  margin: 0;
  color: white;

  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;

  .kpi-column--collapsed & {
    max-width: 10rem;
  }

  max-width: 20rem;
}

.kpi-column__toggle {
  display: flex;
  align-items: center;
  padding: 0.25rem;
  border-radius: var(--bs-border-radius);
}

.kpi-column__content {
  // background-color: white;
}
</style>
